// WhatsApp flutuante com "abrir formulário" ligado no CRM (site.formulario_whats): o menu de escolha
// entre 2 números (Venda+Aluguel com tel1/tel2 de WhatsApp nomeados) era testado ANTES e escondia o
// formulário. Para quem está aqui o formulário ganha do menu e o envio vai para o número principal
// (corretor da ficha, senão tel1). Pedido do cs2606 (02/10) — só para quem está aqui.
export const WHATS_FORMULARIO_PRIMEIRO = new Set<number>([2606]);

export const whatsFormularioPrimeiro = (site: any, codsite?: number): boolean =>
    Boolean(site?.formulario_whats) && WHATS_FORMULARIO_PRIMEIRO.has(Number(site?.id ?? codsite));
